(ns app.login.events (:require ["firebase/app" :refer (initializeApp)]
                               ["firebase/auth" :refer (getAuth OAuthProvider signInWithPopup GoogleAuthProvider signInWithEmailAndPassword createUserWithEmailAndPassword confirmPasswordReset)]
                               [ajax.core :as ajax]
                               [app.endpoints :refer (firebase-token-login reset-password-endpoint verify-email-endpoint resend-verification-code)]
                               [app.events :as events]
                               [clojure.string]
                               [clojure.walk]
                               [day8.re-frame.http-fx]
                               [day8.re-frame.tracing :refer-macros [fn-traced]]
                               [re-frame.core :refer [reg-event-db
                                                      reg-event-fx] :as re-frame]
                               [re-posh.core :as re-posh]
                               [jwt-decode]))



(initializeApp #js {:apiKey "AIzaSyC8ySqYt9jYNjl9Pa0AKaU6kXgJPQaUAUI"
                    :authDomain "strive-dev-243310.firebaseapp.com"
                    :databaseURL "https://strive-dev-243310.firebaseio.com"
                    :storageBucket "strive-dev-243310.appspot.com"
                    :projectId "strive-dev-243310"
                    :messagingSenderId "249228289694"
                    :appId "1:249228289694:web:328acdc945481a1547bd8f"
                    :measurementId "G-XNS1NX6HWX"})
(def auth (getAuth))
(defn jsx->clj
  [x]
  (into {} (for [k (.keys js/Object x)] [k (aget x k)])))

(defn handle-error
  [error]
  (re-posh/dispatch [::add-login-error (clojure.string/replace  (clojure.string/replace (:code (clojure.walk/keywordize-keys (jsx->clj error))) #"auth/" "") #"-" " ")]))


(defn handle-data [data]
  (when-not (nil? data.user.email) (re-posh/dispatch [::add-user-email data.user.email]))
  (re-posh/dispatch [::get-login-data data.user.accessToken]))

(reg-event-fx
 ::get-login-data
 (fn [{:keys [ds]} [_ token-id]]
   {:http-xhrio {:method          :post
                 :uri              firebase-token-login
                 :format          (ajax/json-request-format)
                 :params          #js {:id_token token-id :is_app false}
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8081"
                 :on-success      [:get-login-success]
                 :on-failure      [:endpoint-request-error]}}))

(reg-event-fx
 ::reset-password
 (fn [{:keys [ds]} [_ email]]
   {:http-xhrio {:method          :post
                 :uri             reset-password-endpoint
                 :format          (ajax/json-request-format)
                 :params          (clj->js  email)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [:get-reset-success]
                 :on-failure      [:endpoint-request-error]}}))
(reg-event-fx
 ::verify-email
 (fn [{:keys [ds]} [_ email]]
   {:http-xhrio {:method          :post
                 :uri             verify-email-endpoint
                 :format          (ajax/json-request-format)
                 :params          (clj->js  email)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [:get-login-success]
                 :on-failure      [:endpoint-request-error]}}))

(reg-event-fx
 ::resend-code
 (fn [{:keys [ds]} [_ email]]
   {:http-xhrio {:method          :post
                 :uri             resend-verification-code
                 :format          (ajax/json-request-format)
                 :params          (clj->js  email)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [:resend-code-success]
                 :on-failure      [:endpoint-request-error]}}))


(reg-event-fx
 ::signInWithOutlookAuth
 (fn [_ [_ data]]
   (let [microsoft-provider (OAuthProvider. "microsoft.com")]
     (.addScope microsoft-provider "mail.read")
     (-> (signInWithPopup auth microsoft-provider)
         (.then handle-data data)
         (.catch handle-error)))))

(reg-event-fx
 ::signInWithGoogleAuth
 (fn-traced [_ [_ _]]
            (let [googleProvider (GoogleAuthProvider.)]
              (.addScope googleProvider "https://www.googleapis.com/auth/userinfo.profile")
              (.addScope googleProvider "https://www.googleapis.com/auth/userinfo.email")
              (-> (signInWithPopup auth googleProvider)
                  (.then handle-data)
                  (.catch handle-error)))))



(reg-event-fx
 ::signInWithEmail
 (fn [_ [_ {:keys [email password]}]]
   (-> (signInWithEmailAndPassword auth email password)
       (.then handle-data)
       (.catch handle-error))))



(reg-event-fx
 ::signUpWithEmail
 (fn [_ [_ {:keys [email password]}]]
   (-> (createUserWithEmailAndPassword auth email password)
       (.then handle-data)
       (.catch (fn [data] (if (= (:code (clojure.walk/keywordize-keys (jsx->clj data))) "auth/email-already-in-use")
                            (re-frame/dispatch [::signInWithEmail {:email email :password password}])
                            (re-posh/dispatch [::add-login-error (clojure.string/replace  (clojure.string/replace (:code (clojure.walk/keywordize-keys (jsx->clj data))) #"auth/" "") #"-" " ")])))))))

(reg-event-fx
 ::password-change
 (fn [_ [_ {:keys [password code]}]]
   (-> (confirmPasswordReset auth code password)
       (.then (fn [] (re-frame/dispatch [::events/navigate [:reset-password-success]])))
       (.catch handle-error))))

(reg-event-fx
 :get-reset-success
 (fn [_ [_ _]]
   (re-frame/dispatch [::events/navigate [:reset-password-email]])))

(reg-event-fx
 :get-login-success
 (fn [_ [_ {:keys [verification token display_name profile_image_url]}]]
   (if verification
     (re-frame/dispatch [::events/navigate [:verify-email]])
     (re-frame/dispatch [::add-user token]))
   (when-not (nil? display_name) (re-posh/dispatch [::add-user-name display_name]))
   (when-not (nil? profile_image_url) (re-posh/dispatch [::add-user-profile-pic profile_image_url]))))

(reg-event-fx
 :endpoint-request-error
 (fn [_ [_ {:keys [response]}]]
   (if-not (nil? (:message response))
     (re-posh/dispatch [::add-login-error (:message response)])
     (re-posh/dispatch [::add-login-error (:content response)]))))

(re-posh/reg-event-ds
 ::add-token
 (fn-traced [_ [_ val]]
            [[:db/add 5 :user/token val]]))

(re-posh/reg-event-ds
 ::add-user-email
 (fn-traced [_ [_ val]]
            [[:db/add 5 :user/email val]]))

(re-posh/reg-event-ds
 ::add-user-password
 (fn-traced [_ [_ val]]
            [[:db/add 5 :user/password val]]))

(re-posh/reg-event-ds
 ::add-user-name
 (fn-traced [_ [_ val]]
            [[:db/add 5 :user/name val]]))

(re-posh/reg-event-ds
 ::add-user-profile-pic
 (fn-traced [_ [_ val]]
            ;; (println val)
            [[:db/add 5 :user/profile-pic val]]))



(re-posh/reg-event-ds
 ::add-login-error
 (fn-traced [_ [_ val]] 
            [[:db/add 6 :error/value (or val "")]
             [:db/add 6 :error/show true]]))

(re-posh/reg-event-ds
 ::remove-login-error
 (fn-traced [_ [_ _]]
            [[:db/add 6 :error/value ""]
             [:db/add 6 :error/show false]]))

(reg-event-db
 ::add-user
 (fn [_ [_ token]]
   (re-posh/dispatch [::add-token token])
   (.setItem (.-localStorage js/window) "token" token)
   ((-> js/window .-CommandBar .-boot) (:id (js->clj (jwt-decode token) :keywordize-keys true)))
  ;;  (js/window.location.assign (str strive-react-endpoint "/folder?token=" token))
   (re-frame/dispatch [::events/navigate [:dashboard]])))
